import { useMemo } from 'react'

import { EVENT_CODE } from '@constants'
import { ActionRow } from '@types'

type UseGetObjectXActionsType = {
  configActions?: ActionRow[]
}

export const useGetObjectXActions = (props: UseGetObjectXActionsType) => {
  const { configActions } = props

  const actionsObject: Record<EVENT_CODE, ActionRow> = useMemo(() => {
    if (!configActions?.length) {
      return {} as Record<EVENT_CODE, ActionRow>
    }

    return configActions.reduce(
      (acc, action) => ({ ...acc, [action.eventCode as string]: action }),
      {}
    ) as Record<EVENT_CODE, ActionRow>
  }, [configActions])

  return { actionsObject }
}
